import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { initializeAnalytics } from './utils/analytics.ts';

initializeAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
